import { useState } from "react";
import AdminManualRecharge from "./AdminManualRecharge";
import AdminCreateCreditPack from "./AdminCreateCreditPack";
import AdminSystemInventory from "./AdminSystemInventory";
import AdminCreditPacks from "./AdminCreditPacks";
import AdminAllCreditRecharges from "./AdminAllCreditRecharges";

export default function SuperAdminDashboard() {



  return (
    <div style={{ border: "1px solid #ddd", padding: 2, borderRadius: 6 }}>

      <h4>SuperAdmin Dashboard</h4>
<AdminCreateCreditPack />
<AdminManualRecharge />
<AdminSystemInventory />
<AdminCreditPacks />
<AdminAllCreditRecharges />
    </div>
  );
}
